module.exports = __webpack_public_path__ + "img/haywire.d6b8868e.jpg";